import { useEffect, useState } from 'react'
import config from '../../../../../config'
import { makeApiRequest } from 'app/lib/api-requester'

export interface OpenGraphDataProxyQueryInput {
  url: string
}

export interface OpenGraphDataProxyQueryOutput {
  title?: string
  image?: string
}

export interface OpenGraphDataProxyQueryHook {
  loading: boolean
  data?: OpenGraphDataProxyQueryOutput
  error?: Error
}

export const useOpenGraphDataProxyQuery = (
  input: OpenGraphDataProxyQueryInput
): OpenGraphDataProxyQueryHook => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState<OpenGraphDataProxyQueryOutput>()
  const [error, setError] = useState<Error>()

  useEffect(() => {
    setLoading(true)
    makeApiRequest<OpenGraphDataProxyQueryOutput>('/api/open-graph-data-proxy', {
      method: 'POST',
      body: JSON.stringify({ url: input.url }),
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((data) => {
        setData(data)
        setLoading(false)
      })
      .catch((error) => {
        setError(error)
        setLoading(false)
      })
  }, [input.url])

  return { loading, data, error }
}
